var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0932 18.7844L16.2936 16.5841C16.7424 16.1352 16.8977 15.472 16.7162 14.8638C16.5743 14.3881 16.4143 13.8164 16.308 13.3274C16.2097 12.8752 15.8129 12.5 15.3501 12.5H14.0932C13.1677 12.5 12.4076 13.2532 12.5091 14.1732C13.2809 21.1663 18.8337 26.7191 25.8268 27.4909C26.7468 27.5924 27.5 26.8323 27.5 25.9068V24.6499C27.5 24.1872 27.1233 23.8075 26.6679 23.7247C26.1657 23.6333 25.6343 23.4837 25.1897 23.3419C24.5509 23.1382 23.8409 23.2814 23.3669 23.7554L21.2156 25.9068",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNo);
export default __webpack_public_path__ + "static/media/Mobile_no.ec5c44f6f143c430079c7cf9da8fe1fc.svg";
export { ForwardRef as ReactComponent };